<!-- Datepicker.vue -->
<template>
    <DatePicker
        :ref="refId"
        :lang="lang" 
        :type="type" 
        valueType="format" 
        class="datepicker" 
        :format="format" 
        input-class="form_control" 
        :placeholder="placeholder" 
        :disabled="disabled"
        :value="defaultDate"
        @change="fn_change"
        />
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import { datepickerSetoption } from '@/data/Datapicker_option';

    export default {
        name: 'datePicker',
        props: {
            refId: {
                type: String,
                default: 'datepicker'
            },
            type: {
                type: String,
                default: null
            },
            format: {
                type: String,
                default: 'YYYY-MM-DD'
            },
            placeholder: {
                type: String,
                default: 'YYYY-MM-DD'
            },
            defaultDate: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                lang: datepickerSetoption,
            } 
        },
        components: {
            DatePicker
        },
        methods: {
            fn_change: function(payload) {
                this.date = payload;
                console.log("@@@@ fn_change : "+this.date);
                this.$emit('input',payload);   
                this.$refs.datepicker.closePopup();                    
            }
        }
    };
</script>